import moment from 'moment';
import i18n from './themes/i18n';

function generate_random() {
  const s = Math.ceil(Math.random() * 20000002);
  return s;
}

export default { generate_random };

export const PENDING = 'PENDING';
export const COMPLETED = 'COMPLETED';

export const SHORT_ANSWER = 'SHORT_ANSWER';

export const LEAVE_ADVANCE = 'Leave Advance';
export const LEAVE_ENCASHMENT = 'Leave Encashment';

export const languages = {
  ar: 'ar',
  en: 'en',
};

export const arabicDataGrid = {
  noRowsLabel: 'عذرًا، لا توجد سجلات مطابقة',
  MuiTablePagination: {
    labelRowsPerPage: 'عدد الصفوف لكل صفحة',
    noRowsLabel: 'عذرًا، لا توجد سجلات مطابقة',

    labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} من ${count}`,
  },
};

export function formatTimeDifference(date) {
  const _date = moment(date);

  const currentTime = moment();

  const minutes = currentTime.diff(_date, 'minutes');

  if (minutes < 1) {
    return i18n.t('few-seconds-ago');
  } else if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? i18n.t('min') : i18n.t('mins')}`;
  } else if (minutes < 1440) {
    // 1440 minutes in a day (24 hours)
    const hours = Math.floor(minutes / 60);
    return `${hours} ${hours === 1 ? i18n.t('hour') : i18n.t('hour')}`;
  } else {
    const days = Math.floor(minutes / 1440);
    return `${days} ${days === 1 ? i18n.t('day') : i18n.t('day')}`;
  }
}

export const convertUtcToDate = (
  _date,
  format,
  _offset,
  convertToUTC = true,
) => {
  moment.updateLocale('ar', {
    meridiem: (hours) => {
      return hours < 12 ? i18n.t('am') : i18n.t('pm');
    },
  });

  moment.locale(i18n.language);

  let date = null;

  if (!moment(_date).isValid()) {
    if (convertToUTC) {
      date = new Date(
        new Date(`1970-01-01 ${_date}`).toLocaleString('en-US', {
          timeZone: 'UTC',
        }),
      );
    } else {
      date = new Date(`1970-01-01 ${_date}`);
    }
  }

  if (moment(_date).isValid()) {
    if (convertToUTC) {
      date = new Date(
        new Date(_date).toLocaleString('en-US', { timeZone: 'UTC' }),
      );
    } else {
      date = new Date(_date);
    }
  }

  const offset = _offset ?? Math.abs(date.getTimezoneOffset());

  const epoch = date.getTime();

  const epochWithOffset = epoch + offset * 60 * 1000;

  const result = moment(epochWithOffset).format(format);

  return result;
};

export const convertDateToUTC = (_date, format, _offset, resetTime) => {
  moment.updateLocale('ar', {
    meridiem: (hours) => {
      return hours < 12 ? i18n.t('am') : i18n.t('pm');
    },
  });

  moment.locale(i18n.language);

  let date = null;

  if (!moment(_date).isValid()) {
    date = new Date(`1970-01-01 ${_date}`);
  }

  if (moment(_date).isValid()) {
    date = new Date(_date);
  }

  if (resetTime) date.setHours(0, 0, 0, 0);

  const offset = _offset ?? Math.abs(date.getTimezoneOffset());

  const epoch = date.getTime();

  const epochWithOffset = epoch - offset * 60 * 1000;

  const result = moment(epochWithOffset).format(format);

  return result;
};

export const convertDateToEpochUTC = (date) => {
  const epoch = date.getTime();

  return epoch;
};

export function getCurrentTimeZone() {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timeZone;
}

export const baseTimeFormatting = 'hh:mm a';

export const baseDateFormatting = 'DD MMM, YYYY';
export const time24Formatting = 'HH:mm';

export const baseMonthYearFormatting = "MMM' YYYY";

export const baseDateTimeFormatting = 'YYYY-MM-DD HH:mm';

export const defaultDateFormatting = 'YYYY-MM-DD';

export const timeShiftDateFormat = 'DD MMM';

export const baseDateFormat = (date, format) => {
  const momentClone = moment(date);

  momentClone.locale(i18n.language);

  return momentClone.format(format ?? 'YYYY-MM-DD');
};

export const payloadValidator = (file) => {
  const allowedDocTypes = ['application/pdf', 'application/msword'];
  const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
  const allowedSize = 3.2 * 1024 * 1024;
  const hasInvisibleChars = /[\u200B-\u200F\u202A-\u202E\u2066-\u2069]/.test(file?.name);
  const hasInvalidSpecialChars = /[^\w\s\d\-_,;[\]().]/.test(file?.name);
``
  if (hasInvisibleChars) {
    return { isValid: false, message: 'The file name contains invisible or invalid Unicode characters.' };
  }

  if (hasInvalidSpecialChars) {
    return { isValid: false, message: 'The file name contains special characters that are not allowed.' };
  }
  if (!file) {
    return { isValid: false, message: 'File is required' };
  }
  if (allowedDocTypes.includes(file?.type)) {
    if (file?.size <= allowedSize) return { isValid: true };
    else return { isValid: false, message: 'File size exceeds 3MB limit.' };
  } else if (allowedImageTypes.includes(file?.type)) {
    if (file?.size <= allowedSize) return { isValid: true };
    else return { isValid: false, message: 'File size exceeds 3MB limit.' };
  } else {
    return { isValid: false, message: 'Invalid file type' };
  }
}
